import { AbstractControl, ValidatorFn } from '@angular/forms';

/*
 * No params required.
 * Takes a formControlName and uses data for the value
 * Usage:
 *    import { customSelectRequiredValidator } from 'pf_styleguide';
 *
 * Example:
 *     this.form = this.fb.group({
 *          anything: ['', [customSelectRequiredValidator()]]
 *     });
*/

export function customSelectRequiredValidator(): ValidatorFn {

    return (control: AbstractControl): {[key: string]: any} => {
        let isValid = false;
        const data = control.value as ISelectMolecule;

        if (data && data.data) {
            isValid = true;
        }

        return isValid ? undefined : { invalidSelectRequired: { value: data }} ;
    };
}

export interface ISelectMolecule {
    description: string;
    icon?: string;
    data: any;
}
